import { render, staticRenderFns } from "./Form16Layout.vue?vue&type=template&id=12a41eb2&scoped=true"
import script from "./Form16Layout.vue?vue&type=script&lang=ts"
export * from "./Form16Layout.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=12a41eb2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a41eb2",
  null
  
)

export default component.exports